import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "components/shared/toast/toast";
import { FORM, NOTIFICATION } from "services/apiEndpoints";
import { privateGet, privatePut } from "services/privateRequest";
import { makeQueryString, traverseTree, updateTree } from "utils/utils";

const initialState = {
    notification: [],
    loader: false
};

// export const getNotificationData = createAsyncThunk(
//     "notification/getNotificationData",
//     async ({ rejectWithValue, dispatch, signal }) => {
//         try {
//             const queryString = makeQueryString(NOTIFICATION, {});
//             const { data } = await privateGet(queryString, { signal });
//             console.log('data', data)
//             return {
//                 forms: data?.data?.forms || [],
//                 totalCount: data?.data?.totalForms || 0,
//             };
//         } catch (error) {
//             rejectWithValue(error);
//             return error;
//         }
//     }
// );
export const getNotificationData = createAsyncThunk(
    "notification/getNotificationData",
    async (params) => {
        const res = await privateGet(NOTIFICATION, { params });
        // console.log("res :>> ", res);
        if (res?.data?.success) {

            return {
                notification: res?.data?.data || [],
            };
        } else {
            return {
                notification: [],
            };
        }

    }
);
export const readNotificationData = createAsyncThunk(
    "notification/putNotificationData",
    async (id, { rejectWithValue, dispatch, signal }) => {
        const res = await privatePut(`${NOTIFICATION}/${id}`, "", null);

    }
);
export const updateNotificationData = createAsyncThunk(
    "notification/updateNotificationData",
    async (params) => {
        const res = await privatePut(NOTIFICATION, "", null);
        // console.log("res :>> ", res);
        if (res?.data?.success) {
            return {
                notification: [],
            };
        }

    }
);

const notificationSlice = createSlice({
    name: "notification",
    initialState,
    reducers: {

    },
    extraReducers: {
        [getNotificationData.pending]: (state) => {
            state.loader = true;
        },
        [getNotificationData.fulfilled]: (state, action) => {
            state.notification = action.payload.notification;
            state.loader = false;
        },
        [getNotificationData.rejected]: (state) => {
            state.loader = false;
        },
        [updateNotificationData.pending]: (state) => {
            state.loader = true;
        },
        [updateNotificationData.fulfilled]: (state, action) => {
            state.notification = action.payload.notification;
            state.loader = false;
        },
        [updateNotificationData.rejected]: (state) => {
            state.loader = false;
        },
        // [readNotificationData.pending]: (state) => {
        //     state.loader = true;
        // },
        // [readNotificationData.fulfilled]: (state, action) => {
        //     state.notification = action.payload.notification;
        //     state.loader = false;
        // },
        // [readNotificationData.rejected]: (state) => {
        //     state.loader = false;
        // },
    },
});

export const {
    setDroppedItems,

} = notificationSlice.actions;
export default notificationSlice.reducer;
